import useDistricts from './useDistricts';

export default useDistricts;
